$ = require('jquery')


module.exports =
	init: (payload) ->
		{$target} = payload

		isTouch = $('html').hasClass('touch')

		if $target.find('.menu-secondary__link').length
			if isTouch
				$(document)
					.on('touchend', (e) ->
						if not $(e.target).closest('.menu-secondary__submenu').length
							$('.menu-secondary__submenu.is-open').removeClass('is-open')
							$('.menu-secondary__link.is-hover').removeClass('is-hover')
							$('.menu-secondary__wrap').next('.menu-secondary__submenu').remove()

						if $(e.target).closest('.menu-secondary__link').length
							$link = $(e.target).closest('.menu-secondary__link')

							if $link.next('.menu-secondary__submenu').length
								$link.addClass('is-hover')

								$('.menu-secondary__link').not($link).removeClass('is-prevented')

								if $link.hasClass('is-prevented')
									$link.removeClass('is-prevented')
								else
									e.preventDefault()
									$link.addClass('is-prevented')
									$submenu = $link.next('.menu-secondary__submenu')
									$submenu.parents('.menu-secondary__wrap').after($submenu.clone().addClass('is-open'))
						else
							$('.menu-secondary__link.is-prevented').removeClass('is-prevented')
					)
			else
				$(document)
					.on('mouseover', (e) ->
						$('.menu-secondary__submenu.is-open').removeClass('is-open')
						$('.menu-secondary__link.is-hover').removeClass('is-hover')

						if $(e.target).closest('.menu-secondary__link').length
							$target = $(e.target).closest('.menu-secondary__link').addClass('is-hover')
							offset = $target.position().left

							$target.next('.menu-secondary__submenu').addClass('is-open').css('left', offset)
						else if $(e.target).closest('.menu-secondary__submenu').length
							$submenu = $(e.target).closest('.menu-secondary__submenu')
							$link = $submenu.prev('.menu-secondary__link')

							$submenu.addClass('is-open')
							$link.addClass('is-hover')
					)



/** WEBPACK FOOTER **
 ** ./src/js/components/secondarySubmenu.coffee
 **/